import React from 'react';
import { GoogleAnalytic } from 'src/app/services/GoogleAnalytic';
import { PhinxApp } from './lib/profiles/PhinxApp';

GoogleAnalytic.initialize();

export const App = () => <PhinxApp />;

